module.exports = __webpack_public_path__ + "img/eu.ff9546c2.svg";